import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  securityDepositAmount: null,
  isSecurityDepositWaived: null,
  isOnlineToolsEnabled: null,
  monthlyRent: null,
  rentGuaranteeFee: 45,
  tenantPaymentAmount: null,
  landlordReceiptAmount: null,
  paymentMethod: null,
  isEnabled: null,
  isInterested: true,
});

const rentGuarantee = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.RENT_GUARANTEE_UPDATE_MONTHLY_RENT:
      return {
        ...state,
        monthlyRent: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_SECURITY_DEPOSIT_AMOUNT:
      return {
        ...state,
        securityDepositAmount: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_IS_SECURITY_DEPOSIT_WAIVED:
      return {
        ...state,
        isSecurityDepositWaived: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_TENANT_PAYMENT_AMOUNT:
      return {
        ...state,
        tenantPaymentAmount: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_LANDLORD_RECRIPT_AMOUNT:
      return {
        ...state,
        landlordReceiptAmount: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_IS_ONLINE_TOOLS_ENABLED:
      return {
        ...state,
        isOnlineToolsEnabled: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_IS_INTERESTED:
      return {
        ...state,
        isInterested: payload,
      };
    case DispatchConstants.RENT_GUARANTEE_UPDATE_IS_APPLICATIONS_ENABLED:
      return {
        ...state,
        isApplicationsEnabled: payload,
      };
    default:
      return state;
  }
};

export default rentGuarantee;
